module.exports = __webpack_public_path__ + "static/media/html.5f20a9c3.jpg";